module.exports = __webpack_public_path__ + "static/img/weather_001.0b4dcb22.svg";